import { WebMapServiceImageryProvider } from 'cesium'
import { defaults } from 'lodash-es'
export class GeoserverWMSProvider extends WebMapServiceImageryProvider {
  constructor(
    opt: { url: string; layers: string },
    args?: Partial<WebMapServiceImageryProvider.ConstructorOptions>
  ) {
    super({
      ...opt,
      ...args,
      parameters: defaults(args?.parameters, {
        service: 'WMS',
        version: '1.1.1',
        request: 'GetMap',
        format: 'image/png',
        transparent: true,
        maximumLevel: 18,
        minimumLevel: 1,
      }),
    })
  }
}
